module.exports = __webpack_public_path__ + "img/panel_risk_off.891c4880.svg";